import React, { Fragment, FunctionComponent } from 'react';
import { storyblokEditable } from '@storyblok/react';

import { Heading, HeadingKindType, MediaBlock9 } from '@savebetter/components';

import { useMediaPercentageProps } from '../hooks/useMediaPercentageProps';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { MediaBlockContentProps } from './MediaBlockContent';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { RichText } from './RichText';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  title?: string;
  headingKind?: HeadingKindType;
  media: MediaProps[];
  content: MediaBlockContentProps[];
  link: LinkProps[];
}

interface MediaSection2Props extends PageSectionProps {
  blok: Blok;
}

export const MediaSection2: FunctionComponent<React.PropsWithChildren<MediaSection2Props>> = ({
  blok,
  sectionClassName
}) => {
  const {
    hasBackground,
    hasBorder,
    title,
    headingKind,
    media = [],
    content,
    link = [],
    hasPaddingBottom,
    hasPaddingTop
  } = blok;

  const readMore = link.length > 0 ? link[0] : null;

  const { getMediaProps } = useMediaPercentageProps();

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      {title && <PageSectionHeader headingKind={headingKind}>{title}</PageSectionHeader>}
      <MediaBlock9 mediaProps={getMediaProps(media[0])} readMore={readMore} {...storyblokEditable(blok)}>
        {content.map(({ _uid, heading, content }) => (
          <Fragment key={_uid}>
            <Heading
              className="mt-large md:first:mt-0 lg:mt-large lg:first:mt-0"
              kind="3"
              color="text-black"
              level={title ? '3' : '2'}
            >
              {heading}
            </Heading>
            <RichText content={content} className={heading ? 'mt-4' : ''} />
          </Fragment>
        ))}
      </MediaBlock9>
    </Section>
  );
};
